<template>
    <header class="header" :class="$route.meta.headerClass">
        <div class="header__container">
            <btn-back v-if="$route.meta.back" @click="toRoute()" />
            <router-link to="/" class="header__logo">
                <div class="header__name"></div>
                <div class="header__halal" v-if="$route.path !== '/stock/5' || !displayMobile"></div>
            </router-link>
            <div class="header__menu">
                <ul class="header__items">
                    <template v-if="$route.meta.menuDelivery">
                        <li class="header__item" v-for="page in pages.slice(0, 3).concat(pages.slice(-1).concat(pages.slice(5, 6)))" :key="page.id">
                            <template v-if="page.name === 'Скачать приложение'">
                                <a :href="page.to">{{ page.name }}</a>
                            </template>
                            <template v-else>
                                <RouterLink :to="page.to" activeClass="active" exactActiveClass="active">{{ page.name }}</RouterLink>
                            </template>
                        </li>
                    </template>
                    <template v-else>
                        <li class="header__item" v-for="page in pages.slice(3)" :key="page.id">
                            <template v-if="page.name === 'Вакансии'">
                                <a :href="page.to" target="_blank">{{ page.name }}</a>
                            </template>
                            <template v-else>
                                <RouterLink :to="page.to" activeClass="active" exactActiveClass="active">{{ page.name }}</RouterLink>
                            </template>
                        </li>
                    </template>
                </ul>
            </div>
            <lang-select />
            <btn-mobile @click="isMobile = true" />
            <btn-profile v-if="$route.meta.profile" @click="toProfile()" />
            <btn-cart v-if="$route.path === '/profile'" @click="isCart = true" :totalCountCart="totalCountCart" />
        </div>
    </header>
    <the-mobile :isMobile="isMobile" @close="isMobile = false" @open-login-modal="openLoginModal" />
    <login-modal v-if="isLoginModal" @click="isLoginModal = false" @close="isLoginModal = false" @auth="auth = true" />
    <cart-modal v-if="isCart" @close="isCart = false" :totalCountCart="totalCountCart" :product="product" @minus-to-cart="minusToCart" @plus-to-cart="plusToCart" @add-to-cart="addToCart" @addressChange="changeCartAddress()" />
</template>

<script>
import BtnBack from "./UI/BtnBack.vue";
import LoginModal from "./modals/LoginModal.vue";
import TheMobile from "./TheMobile.vue";
import BtnCart from "./UI/BtnCart.vue";
import BtnMobile from "./UI/BtnMobile.vue";
import BtnProfile from "./UI/BtnProfile.vue";
import LangSelect from "./UI/LangSelect.vue";
import CartModal from "@/components/modals/CartModal.vue";
import { sameCartItem, withRequiredMods } from "@/utils/productMods";
export default {
    components: { TheMobile, LangSelect, BtnMobile, BtnProfile, LoginModal, BtnCart, BtnBack, CartModal },
    data() {
        return {
            isCart: false,
            isMobile: false,
            isLoginModal: false,
            pages: [
                { id: 0, name: "На главную", to: "/" },
                { id: 1, name: "Скачать приложение", to: "/discounts" },
                //{ id: 2, name: "Условия доставки", to: "/delivery" },
                { id: 3, name: "Акции", to: "/stocks" },
                //{ id: 4, name: "Туристам", to: "/tourists" },
                { id: 5, name: "Рестораны", to: "/restaraunts" },
                { id: 6, name: "Заказать", to: "/menu" },
                { id: 7, name: "О нас", to: "/about-us" },
                { id: 8, name: "Вакансии", to: "https://rabota.tubatay.com/" },
                { id: 9, name: "Контакты", to: "/contacts" },
            ],
            token: localStorage.getItem("token"),
            userPhone: localStorage.getItem("phone"),
            open_cart: localStorage.getItem("open_cart"),
            auth: localStorage.getItem("auth") ?? false,
        };
    },
    methods: {
        toProfile() {
            this.auth ? this.$router.push("/profile") : (this.isLoginModal = true);
        },
        toRoute() {
            if (this.$router.path === "/menu" || this.$router.path === "/profile") {
                this.isCart = false;
                window.location.reload();
            } else if (this.$router.path !== window.location.href) {
                window.location = window.location.href.split("/?")[0];
            } else {
                this.$router.go(-1);
            }
        },
        changeCartAddress() {
            this.isCart = false;
            this.isMethodOrderModal = true;
        },
        openLoginModal() {
            this.isLoginModal = true;
            this.isMobile = false;
        },
        totalCountCart() {
            const array = JSON.parse(localStorage.getItem("cart")) ?? [];
            let items = [];
            if (array) {
                for (let i = 0; i < array.length; i++) {
                    if (array[i].type !== "discounted") {
                        items.push(array[i]);
                    }
                }
            }
            return items.reduce((acc, item) => acc + Number(item.quantity ?? item.count ?? 0), 0);
        },
        totalPriceCart() {
            const array = JSON.parse(localStorage.getItem("cart")) ?? [];
            let items = [];
            if (array) {
                for (let i = 0; i < array.length; i++) {
                    if (array[i].type !== "discounted") {
                        items.push(array[i]);
                    }
                }
            }
            return items.reduce((acc, item) => acc + Number(item.final_price ?? item.price ?? 0) * Number(item.quantity ?? item.count ?? 0), 0);
        },
        addToCart(product) {
            const delivery_data = JSON.parse(localStorage.getItem("delivery_data"));
            const pickup_data = JSON.parse(localStorage.getItem("pickup_data"));
            const array = JSON.parse(localStorage.getItem("cart")) ?? [];
            if (!delivery_data && !pickup_data) {
                this.isMethodOrderModal = true;
            }
            const normalized = withRequiredMods(product);
            if (!normalized) return;
            const elem = array.find((item) => sameCartItem(item, normalized));
            if (elem) {
                const quantityKey = Object.prototype.hasOwnProperty.call(elem, "quantity") ? "quantity" : "count";
                elem[quantityKey] = Number(elem[quantityKey] || 0) + 1;
            } else {
                array.push({ ...normalized, quantity: 1, count: 1 });
            }
            localStorage.setItem("cart", JSON.stringify(array));
        },
        plusToCart(product) {
            const array = JSON.parse(localStorage.getItem("cart")) ?? [];
            const elem = array.find((item) => sameCartItem(item, product));
            if (!elem) return;
            const quantityKey = Object.prototype.hasOwnProperty.call(elem, "quantity") ? "quantity" : "count";
            elem[quantityKey] = Number(elem[quantityKey] || 0) + 1;
            localStorage.setItem("cart", JSON.stringify(array));
        },
        minusToCart(product) {
            const array = JSON.parse(localStorage.getItem("cart")) ?? [];
            const elem = array.find((item) => sameCartItem(item, product));
            if (!elem) return;
            const quantityKey = Object.prototype.hasOwnProperty.call(elem, "quantity") ? "quantity" : "count";
            const index = array.indexOf(elem);
            if (Number(elem[quantityKey]) > 1) {
                elem[quantityKey] = Number(elem[quantityKey]) - 1;
            } else {
                array.splice(index, 1);
            }
            localStorage.setItem("cart", JSON.stringify(array));
        },
    },
    watch: {
        token(value) {
            value ? true : false;
        },
        $route: {
            handler: function (search) {
                if (search.fullPath == "/profile") {
                    this.pages[0].name = "Назад";
                    this.pages[0].to = "/menu";
                } else {
                    this.pages[0].name = "На главную";
                    this.pages[0].to = "/";
                }
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {
        displayMobile() {
            return window.innerWidth <= 768;
        },
    },
};
</script>

<style scoped>
.header {
    z-index: 3;
    width: 100%;
    min-height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0 0 24px 24px;
    padding: 0 20px;
    background: rgba(255, 255, 255, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    backdrop-filter: blur(5px);
}
.header .btn-back {
    margin-right: 10px;
}
@media (max-width: 768px) {
    .header {
        min-height: 56px;
        border-radius: 0 0 16px 16px;
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
    }
}
.header__container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}
.header__logo {
    display: flex;
    align-items: center;
}
@media (max-width: 768px) {
    .header__container {
        justify-content: space-between;
    }
    .header__logo {
        flex: 1 1 auto;
        justify-content: center;
    }
}
.header__name,
.header__halal {
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}
.header__name {
    background-image: url("@/assets/img/svg/logo_daily.svg");
    width: 200px;
    height: 30px;
}
.header__halal {
    background-image: url("@/assets/img/svg/halal.svg");
    width: 28px;
    height: 28px;
    margin-left: 5px;
}
@media (max-width: 768px) {
    .header__menu {
        display: none;
    }
    .header__name {
        width: 172px;
    }
}
.header__items {
    display: flex;
    flex-wrap: wrap;
    margin-left: 75px;
    padding: 10px 0;
}
@media (max-width: 1200px) {
    .header__items {
        margin-left: 35px;
    }
}
.header__item {
    margin-right: 50px;
    padding: 10px 0;
}
.header__item a {
    font-size: 14px;
    line-height: 22px;
    color: #1f2120;
    position: relative;
    font-family: "Nunito Sans SemiBold";
}
.header__item a::before {
    content: "";
    position: absolute;
    bottom: 0;
    width: 0;
    height: 1px;
    background: #1f2120;
}
.header__item a:hover::before,
.header__item a:focus::before {
    width: 100%;
    transition: 0.2s ease 0.2s;
}
.header__item .active::before {
    width: 100% !important;
}
.header._blur {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(5px);
    position: fixed;
    top: 0;
    left: 0;
}
.header._blur .header__item a {
    color: #fff;
}
.header._blur .header__item a::before {
    background: #fff;
}
.header._blur .header__logo {
    background-image: url("@/assets/img/logo144х30.png");
    background-repeat: no-repeat;
}
.header._blur .header__arrow {
    background-image: url("@/assets/img/svg/select-white.svg");
    background-repeat: no-repeat;
}
.header._blur .btn-mobile__burger span {
    background: #fff;
}
</style>
